<template>
  <div class="content-wrapper__layout">
    <side-nav></side-nav>

    <div class="content-wrapper__main-content-wrapper content-wrapper__main-content-wrapper--13">
      <system-nav></system-nav>
      <section class="main-content">
        <section class="section">
          <div class="section__titles">
            <h4 class="section__title">Causas</h4>
            <button class="btn btn--primary btn--outline" @click.prevent="showNewCauseDialog()">Nueva causa</button>
          </div>
          <div v-if="disabledExists" class="tabs">
            <div :class="`tab${status ? ' tab--active' : ''}`" @click.prevent="loadData(true)">Habilitadas</div>
            <div :class="`tab${!status ? ' tab--active' : ''}`" @click.prevent="loadData(false)">Deshabilitadas</div>
          </div>
          <div class="list">
            <div class="list__item" v-for="cause in causes" :key="cause.id">
              <div class="item__info">
                <p>{{ cause.name }}</p>
              </div>
              <div class="item__actions">
                <DropdownMenu>
                  <template #button>
                    <button class="btn btn--icon btn--circle">
                      <img class="icon" src="@/assets/images/icons/ico_dots--bl.svg">
                    </button>
                  </template>
                  <template #options>
                    <a class="dropdown__option" href="#" @click.prevent="showEditCauseDialog(cause.id)">
                      Modificar
                    </a>
                    <a :class="['dropdown__option', status ? 'dropdown__option--danger' : '']" href="#" @click.prevent="changeStatus(cause.id)">
                      {{ status ? 'Deshabilitar' : 'Habilitar' }}
                    </a>
                  </template>
                </DropdownMenu>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  </div>

  <!-- Nueva causa -->
  <modal-dialog v-if="newCauseDialog">
    <template #title>Nueva causa</template>
    <template #description>Ingresa el correo electrónico al cual deseas enviar la causa</template>
    <template #content>
      <form class="form" @submit.prevent="save()">
        <div class="form__group">
          <label class="form__label" for="name">Nombre</label>
          <input class="form__input" id="name" type="text" v-model.trim="cause.name" :disabled="submitting">
        </div>
        <div class="form__actions">
          <button class="btn btn--primary btn--outline" type="button" @click.prevent="newCauseDialog = false" :disabled="submitting">Cancelar</button>
          <button class="btn btn--primary" type="submit" :disabled="submitting">Crear</button>
        </div>
      </form>
    </template>
  </modal-dialog>

<!-- Editar etiqueta -->
  <modal-dialog v-if="editCauseDialog">
    <template #title>Editar causa</template>
    <template #description>Modifica los campos de la causa</template>
    <template #content>
      <form class="form" @submit.prevent="update()">
        <div class="form__group">
          <label class="form__label" for="name">Nombre</label>
          <input class="form__input" id="name" type="text" v-model.trim="cause.name" :disabled="submitting" required>
        </div>
        <div class="form__actions">
          <button class="btn btn--primary btn--outline" type="button" @click.prevent="editCauseDialog = false" :disabled="submitting">Cancelar</button>
          <button class="btn btn--primary" type="submit" :disabled="submitting">Actualizar</button>
        </div>
      </form>
    </template>
  </modal-dialog>

</template>

<script>
import SideNav from '@/components/SideNav.vue'
import SystemNav from '@/components/SystemNav.vue'
import ModalDialog from '@/components/ModalDialog.vue'
import DropdownMenu from '@/components/DropdownMenu.vue'

export default {
  components: {
    SideNav,
    SystemNav,
    ModalDialog,
    DropdownMenu
  },
  name: 'Causes',
  data () {
    return {
      causes: [],
      newCauseDialog: false,
      cause: {
        id: '',
        name: ''
      },
      submitting: false,
      status: true,
      disabledExists: false,
      editCauseDialog: false
    }
  },
  async created(){
    this.disabledExists = (await this.$axios.get(`causas/total/false`)).data[1] > 0
    await this.loadData(true)
  },
  methods: {
    showNewCauseDialog () {      
      this.cause.name = ''
      this.newCauseDialog = true
    },
    async showEditCauseDialog (id) {
      this.cause = (await this.$axios.get(`causas/${id}`)).data
      this.editCauseDialog = true
    },
    async loadData(status){
      this.status = status
      this.causes = []
      this.causes = (await this.$axios.get(`causas/${this.status}/1`)).data
    },
    async save(){
      this.submitting = true
      const res = await this.$axios.post(`causas/create`, this.cause);
      this.submitting =  false
      if(res.status == 200){
        this.$toast.success(`Causa creada con éxito`);
        await this.loadData(this.status)
        this.newCauseDialog = false;
      }
      else
        this.$toast.error(`Ocurrió un error al crear la Causa`);
    },
    async update(){
      this.submitting = true
      const res = await this.$axios.post(`causas/update/${this.cause.id}`, this.cause);
      this.submitting =  false
      if(res.status == 200){
        this.$toast.success(`Causa modificada con éxito`);
        await this.loadData(this.status)
        this.editCauseDialog = false;
      }
      else
        this.$toast.error(`Ocurrió un error al modificar la Causa`);
    },
    async changeStatus(id){
      if(confirm(this.status ? '¿Desea deshabilitar el elemento seleccionado?' : '¿Desea habilitar el elemento seleccionado?')){
        const res = await this.$axios.post(`causas/status/${id}`);
        if(res.status == 200){
          this.disabledExists = (await this.$axios.get(`causas/total/false`)).data[1] > 0
          this.$toast.success(`Causa modificada con éxito`);
          if(!this.disabledExists) 
            await this.loadData(true)
          else
            await this.loadData(this.status)
        }
      }
    }
  }
}
</script>